<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}">
        <v-row>
            <v-col cols="12" align="center">
                <SheetsTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import SheetsTable from '@/components/lists/derived/SheetsTable'
export default {
    name:'SheetsPage',
    components:{
        SheetsTable
    }
}
</script>